import React from 'react';
import Article1 from './Article1';
import './App.css';

function App() {
  return (
    <div className="App">
      <Article1 />
    </div>
  );
}

export default App;
